// #MapIcons (Fase E) — Library de pictogramas SVG estilo OnePlan para
// markers del mapa y para el PDF. Cada icono se renderiza como círculo de
// color con un pictograma blanco dentro, igual al editor de OnePlan.
//
// Cómo usar:
//   import { buildMarkerIconUrl, ICON_LIBRARY } from './mapIcons';
//   const url = buildMarkerIconUrl({ categoryId: 'infra_sanitarios_baño_caballeros', color: '#0EA5E9' });
//   <Marker icon={{ url, scaledSize: new google.maps.Size(36, 48), anchor: ... }} />
//
// El URL es data:image/svg+xml;utf8,... renderizable directo por Google Maps.

// Catálogo de pictogramas — 24x24 viewBox, paths sin fill (se aplica blanco)
// Cubre los ~30 iconos más comunes de la taxonomía OnePlan en español.
export const ICON_LIBRARY = {
  // — Accesos y salidas —
  door:        'M6 2v20h12V2H6zm10 18H8V4h8v16zm-3-9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z',
  exit:        'M10.09 15.59 11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z',
  entrance:    'M11 7 9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5-5-5zM20 19h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8v2h8v14z',
  evacuation:  'M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9 1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z',

  // — Sanitarios —
  wc_male:     'M8 3a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM3 7h6a1 1 0 0 1 1 1v5H8.5v8.5h-3V13H4V8a1 1 0 0 1-1-1zm10 0a1 1 0 0 1 1-1 1.5 1.5 0 0 0 0-3 1.5 1.5 0 1 0 1.5 1.5h.5a2.5 2.5 0 1 1-3 2.45V7zm6.5 6V8.5L17 4l-2.5 4.5V13H17v8.5h2V13h.5z',
  wc_female:   'M12 1c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM9 7h6c.83 0 1.5.67 1.5 1.5L13 21h-2v-6h-2v6H7L3.5 8.5c0-.83.67-1.5 1.5-1.5h4z',
  wc:          'M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63A2.01 2.01 0 0 0 16.56 7h-.12a2 2 0 0 0-1.9 1.37L12 16h3v6h3zM7.5 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm9 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
  accessible:  'M12 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm-2 4.74L7.85 18l5.4 1.04L14 23h2l-1.04-5L9.5 16.86l.74-3.74h2.85l1.78 3 1.74-1-1.5-2.5h-3.85l.62-3.13c.62.66 1.41 1.16 2.32 1.41V10c-.79-.18-1.36-.7-1.7-1.41l-.95-1.59A2 2 0 0 0 10.32 6L7 7v4h2V8.84z',

  // — Audio / Visual —
  speaker:     'M14 3v2.78l1.5 1.5V3c0-1.1-.9-2-2-2h-9c-.85 0-1.58.53-1.87 1.28L14 13.45V3zM3.41 1.86 2 3.27l3 3V21c0 1.1.9 2 2 2h12c.34 0 .65-.08.93-.23l1.84 1.84 1.41-1.41L3.41 1.86zM9 12c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z',
  camera_cctv: 'M19.18 7H8.95L7.05 5H4V4h12.74L18 5.26 19.18 7zM6 21v-8h12v8H6zm6-9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z',
  stage:       'M2 17h20v2H2zm1.15-4.05L4 11.47l.85 1.48L4 14.43zM6 8h12v8H6V8zm-3 4 1.85 3.21L6 13.36l1.15 1.85L9 13.36l1.15 1.85L12 13.36l1.15 1.85L15 13.36l1.15 1.85L18 13.36l1.15 1.85L21 12l-1.85-3.21L18 10.64l-1.15-1.85L15 10.64l-1.15-1.85L12 10.64l-1.15-1.85L9 10.64 7.85 8.79 6 10.64l-1.85-1.85L3 12z',

  // — Estructuras / Infraestructura —
  tent:        'M12 4 2 21h20L12 4zm0 4 6 11h-3l-3-3-3 3H6l6-11z',
  fence:       'M22 8V2h-2v2h-3V2h-2v2h-3V2H10v2H7V2H5v2H3v6h2v4H3v6h2v2h2v-2h3v2h2v-2h3v2h2v-2h3v2h2v-2h2v-6h-2v-4h2zm-3 0v6H5V8h14zm-9 4h4v2h-4v-2z',
  barrier:     'M19 11H5V8h14v3zm0 2v3H5v-3h14zM3 6v12h18V6H3z',
  building:    'M17 11V3H7v4H3v14h8v-4h2v4h8V11h-4zm-8 8H5v-2h4v2zm0-4H5v-2h4v2zm0-4H5V9h4v2zm6-4h-4V5h4v2zm0 4h-4V9h4v2zm4 8h-4v-2h4v2zm0-4h-4v-2h4v2z',

  // — F&B / Mobiliario —
  food:        'M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z',
  chair:       'M20 8V5c0-1.66-1.34-3-3-3H7C5.34 2 4 3.34 4 5v3c-1.66 0-3 1.34-3 3v5h2.08L4 18h2l1-2h10l1 2h2l.92-2H23v-5c0-1.66-1.34-3-3-3zM6 5c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v3.78c-.61.55-1 1.34-1 2.22v2H7v-2c0-.88-.39-1.67-1-2.22V5zm15 9h-2v-3c0-.55.45-1 1-1s1 .45 1 1v3zM4 11v3H2v-3c0-.55.45-1 1-1s1 .45 1 1z',
  table:       'M20 13H4c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h7v2h2v-2h7c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2zM4 5h16c.55 0 1 .45 1 1v6H3V6c0-.55.45-1 1-1z',

  // — Crowd / Personal —
  crowd:       'M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zM4 18v-2h3v-1.5h2V13c0-.55.45-1 1-1h.5v-1c0-.55.45-1 1-1h1v-.5C12.5 6.57 13.07 6 13.83 6c.45 0 .9.21 1.17.59l1.17 1.81h2.83c1.1 0 2 .9 2 2 0 .65-.31 1.23-.79 1.6L19 14v3c0 1.1-.9 2-2 2v3h-7v-3H7v-1H4v0zM9 16v6h2v-2h2v2h2v-6h-2v-1H9v1z',
  worker:      'M12 6c1.66 0 3-1.34 3-3 0-.55-.15-1.06-.42-1.5L13 4 11.42 1.5C11.15 1.94 11 2.45 11 3c0 1.66 1.34 3 3 3zm-1 1H7v1.78c-1.16.41-2 1.52-2 2.82V14h12v-2.4c0-1.3-.84-2.41-2-2.82V7h-4z',
  vip:         'M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z',

  // — Transporte / Vehículos —
  parking:     'M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z',
  bus:         'M4 16c0 .88.39 1.67 1 2.22V20a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h8v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z',
  ambulance:   'M19 7h-3V5c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H5c-1.1 0-2 .9-2 2v9c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-9-2h4v2h-4V5zm5 12h-2v-2h-2v2h-2v-2H7v-2h2v-2h2v2h2v-2h2v2h2v2h-2v2z',
  car:         'M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z',

  // — Seguridad / Emergencia —
  shield:      'M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z',
  fire:        'M19.48 12.35c-1.57-4.08-7.16-4.3-5.81-10.23.1-.44-.37-.78-.75-.55C9.29 3.71 6.68 8 8.87 13.62c.18.46-.36.89-.75.59-1.81-1.37-2-3.34-1.84-4.75.06-.52-.62-.77-.91-.34C4.69 10.16 4 11.84 4 14.37c.38 5.6 5.11 7.32 6.81 7.54 2.43.31 5.06-.14 6.95-1.87 2.08-1.93 2.84-5.01 1.72-7.69zm-9.28 5.03c1.44-.35 2.18-1.39 2.38-2.31.33-1.43-.96-2.83-.09-5.09.33 1.87 3.27 3.04 3.27 5.08.08 2.53-2.66 4.7-5.56 2.32z',
  warning:     'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z',
  first_aid:   'M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 9h-4v4h-2v-4H7v-2h4V6h2v4h4v2z',

  // — Genéricos —
  pin:         'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z',
  poi:         'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z',
  flag:        'M14.4 6 14 4H5v17h2v-7h5.6l.4 2h7V6z',
  star:        'M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z',
};

// Map de categoryId → iconKey. Si una categoría no aparece, intentamos
// matching por prefijo (ver getIconKey). Si nada matchea → 'pin'.
const CATEGORY_ICON_OVERRIDES = {
  // Legacy ids
  entrance: 'entrance',
  exit: 'exit',
  evacuation: 'evacuation',
  assembly_point: 'crowd',
  risk_zone: 'warning',
  critical: 'fire',
  facility: 'building',
  hospital: 'first_aid',
  vip_perimeter: 'vip',
  first_aid: 'first_aid',
  other: 'pin',
};

// Prefijos de OnePlan IDs → iconKey
const PREFIX_ICON_MAP = [
  ['infra_seguridad_camara', 'camera_cctv'],
  ['infra_seguridad_extintor', 'fire'],
  ['infra_seguridad_primeros', 'first_aid'],
  ['infra_seguridad', 'shield'],
  ['infra_sanitarios_caballero', 'wc_male'],
  ['infra_sanitarios_dama', 'wc_female'],
  ['infra_sanitarios_accesible', 'accessible'],
  ['infra_sanitarios', 'wc'],
  ['infra_audiovisual_bocina', 'speaker'],
  ['infra_audiovisual_camara', 'camera_cctv'],
  ['infra_audiovisual', 'speaker'],
  ['infra_alimentos', 'food'],
  ['infra_mobiliario_silla', 'chair'],
  ['infra_mobiliario_mesa', 'table'],
  ['infra_mobiliario', 'chair'],
  ['infra_estructuras_carpa', 'tent'],
  ['infra_estructuras_escenario', 'stage'],
  ['infra_estructuras', 'building'],
  ['infra_barreras', 'fence'],
  ['infra_branding', 'flag'],
  ['infra_puntos', 'poi'],
  ['infra_transporte_autobus', 'bus'],
  ['infra_transporte_estacionamiento', 'parking'],
  ['infra_transporte', 'bus'],
  ['infra_vehiculos_ambulancia', 'ambulance'],
  ['infra_vehiculos', 'car'],
  ['infra_trafico', 'warning'],
  ['infra_residuos', 'pin'],
  ['infra_agua', 'pin'],
  ['infra_electrico', 'warning'],
  ['areas_publico', 'crowd'],
  ['areas_vip', 'vip'],
  ['areas_', 'pin'],
  ['rutas_evacuacion', 'evacuation'],
  ['rutas_acceso', 'entrance'],
  ['rutas_', 'pin'],
  ['personal_seguridad', 'shield'],
  ['personal_medico', 'first_aid'],
  ['personal_', 'worker'],
];

export function getIconKey(categoryId) {
  if (!categoryId) return 'pin';
  if (CATEGORY_ICON_OVERRIDES[categoryId]) return CATEGORY_ICON_OVERRIDES[categoryId];
  for (const [pref, key] of PREFIX_ICON_MAP) {
    if (categoryId.startsWith(pref)) return key;
  }
  return 'pin';
}

// Genera un SVG data URI con un círculo de color + pictograma blanco
// adentro. Tamaño 36x36 incluyendo el círculo. anchorY=bottom para que el
// pin "se clave" en el lat/lng exacto en Google Maps.
export function buildMarkerIconSvg({ categoryId, color = '#1A56DB', size = 36, ring = '#FFFFFF' }) {
  const iconKey = getIconKey(categoryId);
  const path = ICON_LIBRARY[iconKey] || ICON_LIBRARY.pin;
  const r = size / 2;
  // Pictograma escalado al 60% del círculo, centrado
  const iconSize = size * 0.55;
  const iconOffset = (size - iconSize) / 2;
  const scale = iconSize / 24; // viewBox 24x24
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
    <circle cx="${r}" cy="${r}" r="${r - 2}" fill="${color}" stroke="${ring}" stroke-width="2"/>
    <g transform="translate(${iconOffset}, ${iconOffset}) scale(${scale})" fill="#FFFFFF">
      <path d="${path}"/>
    </g>
  </svg>`;
  return svg;
}

// Versión "drop pin" para Google Maps Marker.icon — tiene una cola hacia
// abajo y anchor en el punto del pin para que la posición del marker sea
// exacta sobre el lat/lng.
export function buildPinIconSvg({ categoryId, color = '#1A56DB', size = 36 }) {
  const iconKey = getIconKey(categoryId);
  const path = ICON_LIBRARY[iconKey] || ICON_LIBRARY.pin;
  const w = size;
  const h = size * 1.25; // ratio para incluir la cola
  const r = size / 2;
  const iconSize = size * 0.5;
  const iconOffset = (size - iconSize) / 2;
  const scale = iconSize / 24;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}">
    <path d="M ${r} ${h - 1} L ${r - 6} ${size - 4} Q ${r} ${size - 6} ${r + 6} ${size - 4} Z" fill="${color}"/>
    <circle cx="${r}" cy="${r}" r="${r - 2}" fill="${color}" stroke="#FFFFFF" stroke-width="2"/>
    <g transform="translate(${iconOffset}, ${iconOffset}) scale(${scale})" fill="#FFFFFF">
      <path d="${path}"/>
    </g>
  </svg>`;
  return svg;
}

export function svgToDataUrl(svg) {
  // encodeURIComponent es seguro para data URIs en todos los browsers
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

// Helper combinado para Google Maps Marker
export function buildMarkerIconUrl({ categoryId, color, size = 36, asPin = true }) {
  const svg = asPin
    ? buildPinIconSvg({ categoryId, color, size })
    : buildMarkerIconSvg({ categoryId, color, size });
  return svgToDataUrl(svg);
}
